import React, { useEffect, useRef } from 'react'
import {BoilerInputProps, Input} from 'b302-frontend-library';

interface Props<T> extends BoilerInputProps<T> {}

function AutoResizableInput<T>(props: Props<T>) {
    const hideRef = useRef<HTMLSpanElement>(null);
    const inputRef = useRef<HTMLInputElement>(null);

    const value = props.form.values[props.id];

    useEffect(() => {
        const resize = () => {
            if (!hideRef.current) return;
            hideRef.current.textContent = value.toString();

            if (!inputRef.current) return;
            inputRef.current.style.width = hideRef.current.offsetWidth + "px";
        }

        resize();
    }, [value])

    return (
        <div className="auto-resizable-input">
            <span className="auto-resizable-input__hide" ref={hideRef} />

            <Input
                form={props.form}
                type="text" onChange={props.onChange} ref={inputRef} id={props.id} />
        </div>
    )
}

export default AutoResizableInput;
